import { VISION_ID } from 'core/constants/products'
import getById from 'utils/DOM/getById'
import store from 'utils/store/withMiddleware'

function handleToggleVision(): void {
  const addonId = +this.getAttribute('data-id')
  const planId = this.getAttribute('data-planId')
  const visionInput = getById(`vision-${planId}-addon-${addonId}`)
  const deleteVision = visionInput && !visionInput.checked

  const state = store.getState()

  const { addonsByPlan, latitudeAddons, dentalAddons, visionAddons } = state

  const latitudePlan = latitudeAddons[planId]
  const dentalPlan = dentalAddons[planId]
  const visionPlan = visionAddons[planId]

  let planAddons = addonsByPlan[planId] || []

  if (dentalPlan === addonId) {
    planAddons = [latitudePlan, dentalPlan].filter(Boolean)
    if (!deleteVision) {
      planAddons.push(VISION_ID)
    }
  } else {
    planAddons = [latitudePlan, dentalPlan, visionPlan].filter(Boolean)
  }

  addonsByPlan[planId] = planAddons
  store.update({ addonsByPlan })
}
export default handleToggleVision
